import { useReducer, useCallback } from 'react'

import ApiService from '../../../helpers/apiservice'

const initialState = {
  loading: false,
  error: null,
  response: null,
  extra: null,
  identifier: null
}

const apiReducer = (currentApiState, action) => {
  switch (action.type) {
    case 'SEND':
      return {
        loading: true,
        error: null,
        response: null,
        extra: action.extra ? action.extra : currentApiState.extra,
        identifier: action.identifier
      }
    case 'RESPONSE':
      return {
        ...currentApiState,
        loading: false,
        response: action.response,
        identifier: action.identifier ? action.identifier : null,
        extra: action.extra ? action.extra : null
      }
    case 'ERROR':
      return {
        ...currentApiState,
        loading: false,
        error: action.errorResponse,
        identifier: action.identifier ? action.identifier : null,
        extra: action.extra ? action.extra : null
      }
    case 'CLEAR':
      return initialState
    default:
      throw new Error('Should not be reached!')
  }
};

const useApi = () => {
  const [apiState, dispatchApi] = useReducer(apiReducer, initialState)

  const clear = useCallback(() => dispatchApi({ type: 'CLEAR' }), [])

  const sendRequest = useCallback(
    ({ apiName, body, reqIdentifier, token, reqExtra } = {}) => {
      dispatchApi({
        type: 'SEND',
        identifier: reqIdentifier,
        extra: reqExtra
      })
      ApiService[apiName](body, token)
        .then(res => {
          if (res) {
            dispatchApi({
              type: 'RESPONSE',
              response: res,
              identifier: reqIdentifier,
              extra: reqExtra
            })
          }
        })
        .catch(error => {
          dispatchApi({
            type: 'ERROR',
            errorResponse: error,
            identifier: reqIdentifier,
            extra: reqExtra
          })
        })
    }, [])

  return {
    isLoading: apiState.loading,
    response: apiState.response,
    error: apiState.error,
    sendRequest: sendRequest,
    reqExtra: apiState.extra,
    reqIdentifier: apiState.identifier,
    clearRequest: clear
  }
}

export default useApi
